/**
 * 应用快速发起区域
 *
 * created by liyaoh 2021-08-09
 */
import React from "react";
import { QuickAddIcon } from "Components/QuickLaunchIcon";

export default function withQuickLaunchArea(params) {
    return function(WrapperComponent) {
        return class OprArea extends React.Component {
            renderArea = newParams => {
                const { appData } = newParams;
                const isShowQuick = !!appData.fastlaunchparam;
                if (!isShowQuick) {return null;}
                /* 快速发起-新增 */
                return (
                    <QuickAddIcon
                        visible={isShowQuick}
                        appData={appData}
                        icon="icon-xinzengyemian"
                        containerClassName="quick-launch-area"
                    />
                );
            };

            render() {
                const newParams = params(this.props);
                if (!newParams.isShow) {return <WrapperComponent {...this.props} />;}
                return (
                    <React.Fragment>
                        <WrapperComponent
                            renderEditCustomArea={this.renderCustomArea}
                            {...this.props}
                        />
                        {this.renderArea(newParams)}
                    </React.Fragment>
                );
            }
        };
    };
}
